import { createApp } from 'vue'
import naive from 'naive-ui'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './core/router'
import { initTheme } from './core/theme'
import './assets/global.scss'
import './assets/mobile.scss'

initTheme()

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(naive)
app.mount('#app')
